export {default as CheckInReminder} from './CheckInReminder.connect';
